import React from 'react';

import { CardContainer, Title, Image, ImageContainer, CardContent, CardText, TextContent } from './styles';
import Baston from '../../assets/images/baston.jpg';
import Button from '../Button';
import { LOW_WHITE, MAIN_BLUE } from '../../styles/Colors';

const Card = ({ title, description, details, image, setOpenModal, setModalInformation }) => {
  return (
    <CardContainer>
      <Title>{title}</Title>
      <ImageContainer>
        <Image src={image} />
      </ImageContainer>
      <CardContent>
        <TextContent>{description}</TextContent>
      </CardContent>
      <Button
        onClick={() => {
          setModalInformation({
            title,
            description,
            details,
            image,
          });
          setOpenModal(true);
        }}
        width='50%'
        height='30px'
        color={LOW_WHITE}
        fontSize='0.9rem'
        background={MAIN_BLUE}
        radius='10px'
        value={'Ver detalles'}
      />
    </CardContainer>
  );
};

export default Card;
